import styled from 'styled-components'

export const HistoricoWrapper = styled.div`
  background-color: ${({ theme }) => theme.cor53}!important;
  border-radius: 8px;
  padding: 10px;
  gap: 20px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  width: 84%;
  position: relative;

  .mantine-Input-wrapper {
    width: 200px;
  }
`

export const Legenda = styled.div`
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #868e96;
`

export const AlertWrapper = styled.div`
  position: absolute;
  right: 30px;
  z-index: 99;
  width: 380px;

  .mantine-Alert-root {
    background: ${({ theme }) => theme.alerta.warning.background};
  }

  .mantine-Alert-message,
  .mantine-Alert-closeButton {
    white-space: normal;
    color: ${({ theme }) => theme.cor9}!important;
  }

  .mantine-Alert-title {
    color: ${({ theme }) => theme.alerta.warning.color};
  }

  svg > path {
    fill: ${({ theme }) => theme.alerta.warning.color};
  }
`
